import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import AdminNavigation from "../AdminNavigation";
import { AddTetProductFields, TETProductManagementFields } from "./Field";
import { validateField } from "../../../pages/functions";
import Select from "../../../forms/Select";
import InputGroup from "../../../forms/InputGroup";
import { api_v2 } from "../../NewIndex.api";
import { withRouter } from "react-router-dom";
import "./Styles.css";
import { REF_DATA } from "../../../constants";
import { getApplicationRegex } from "../../plugins/utils";

const TETAddProduct = (props) => {
  const [fields, setFields] = useState(AddTetProductFields);
  const [affiliateOptions, setAffiliateOptions] = useState([]);
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const fetchAffiliate = useCallback(() => {
    const filteredData = props.referenceData.filter(
      (item) => item.type === "COUNTRIES"
    );
    const countryList =
      (filteredData.length > 0 && filteredData[0].countries) || [];
    const onlyUnique = (value, index, self) => self.indexOf(value) === index;

    const affiliateList = countryList
      .map((country) => country.affiliate)
      .filter(onlyUnique)
      .sort();

    const affiliateOptions = affiliateList.map((affiliate) => ({
      value: affiliate,
      label: affiliate,
    }));
    setAffiliateOptions(affiliateOptions);
  }, []);

  useEffect(() => {
    fetchAffiliate();
  }, []);

  const validate = useCallback((e, field) => {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);

    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      // Emoji detected, prevent it from being added
      showNotification(
        "Error!",
        "Special characters are not allowed",
        "error"
      );
      return;
    } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
      // HTML Tags and Script detected, prevent it from being added
      showNotification(
        "Error!",
        "Submission fails. Input contains prohibited words. Please remove them and try again.",
        "error"
      );
      return;
    } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
      showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return;
    }
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  }, []);

  const CreateTETProductHandler = useCallback(
    (res) => {
      if (res.status === 201) {
        let fieldsValue = fields;
        fieldsValue.affiliate.value = "";
        fieldsValue.tetProduct.value = "";
        setFields({ ...fieldsValue });
        showNotification("Success", "Product is Added Successfully", "success");
        setTimeout(() => {
          props.history.push("/admin/manage-tet-products");
        }, 2000);
      } else if (res.status === 424) {
        showNotification(
          "Information",
          "This product is already available in our system for this Affiliate.",
          "info"
        );
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    },
    [fields, props.history]
  );

  const handleCreateTETProduct = useCallback(() => {
    const payload = {
      affiliate: fields.affiliate.value,
      name: fields.tetProduct.value.trim(),
    };

    api_v2.createTETProduct(payload, CreateTETProductHandler);
  }, [fields]);

  return (
    <div id="manage-admin-list" className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row manage-admin-list-header">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">
                Add Affiliate TET Products
              </h3>
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-md-4">
                <p>Please select Affiliate to add TET product</p>
              </div>
            </div>
            <div className="row">
              <div className=" col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={affiliateOptions}
                  field={fields.affiliate}
                  validate={(e) => validate(e, fields.affiliate)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-xl-12">
                <h4
                  className="mb-3 header-primary"
                  style={{ marginTop: "25px" }}
                >
                  Please enter a TET Product Name
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <InputGroup
                  searchable={false}
                  clearable={false}
                  field={fields.tetProduct}
                  validate={(e) => validate(e, fields.tetProduct)}
                />
              </div>
            </div>

            <div>
              <button
                className="btn btn-lg btn-info btn-rounded"
                onClick={handleCreateTETProduct}
                disabled={
                  fields.affiliate.value === "" ||
                  fields.tetProduct.value === ""
                }
              >
                Add TET Product & Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, { notify })(withRouter(TETAddProduct));



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/V2TETAddTetProduct.js